import Pic1 from './Assets/pic5.jpg'
import Pic2 from './Assets/pic6.jpg'
import Pic3 from './Assets/pp4.jpg'
import Pic4 from './Assets/pp5.jpg'
import Pic5 from './Assets/pp6.jpg'

export const TESTIMONIAL = [
    {
        id: 1,
        img: Pic1,
        username: 'Davies',
        text: 'Superb food, great hospitality and service. I love it!'
    },
    {
        id: 2,
        img: Pic2,
        username: 'Jennifer',
        text: 'Very beautiful interior and even better food'
    },
    {
        id: 3,
        img: Pic3,
        username: 'Micheal',
        text: 'The Fillet Mignon is to die for, I enjoyed it!'
    },
    {
        id: 4,
        img: Pic4,
        username: 'Emma',
        text: 'I do not regret it, even got a complimentary wine'
    },
    {
        id: 5,
        img: Pic5,
        username: 'Riya',
        text: 'The ambience is just top notch!'
    },
]